module.exports = __webpack_public_path__ + "img/icon-speed-light-simple.3b876ee5.svg";